define(
    "diy/undo-redo/SessionFactory",
    [
        'diy/util/UUID',
        'diy/undo-redo/Session'
    ],
    /**
     *
     * @param {diy.util.UUID} UUID
     * @param {module.undoRedo.Session} Session
     * @returns {module.undoRedo.SessionFactory}
     */
    function (UUID, Session) {
        'use strict';
        var SessionFactory;

        /**
         * @class module.undoRedo.SessionFactory
         * @template module.undoRedo.SessionFactory
         * @lends {module.undoRedo.SessionFactory.prototype}
         * @constructor
         */
        SessionFactory = Klazz.extend({
            initialize: function () {

            },
            /**
             *
             * @param {module.undoRedo.SessionManager} sessionManager
             * @returns {module.undoRedo.Session}
             */
            build: function build(sessionManager) {
                var session = new Session(sessionManager);
                session.setKey(UUID.generate());

                return session;
            },
            /**
             * @param {module.undoRedo.SessionManager} sessionManager
             * @param {{key: String, sessionId: String, volatile: Boolean, undo: String[], redo: String[]}} data
             * @returns {module.undoRedo.Session}
             */
            load: function load(sessionManager, data) {
                var session = this.build(sessionManager);
                session
                    .setKey(data.key)
                    .setSessionId(data.sessionId)
                    .setTemporary(data.temporary)
                    .setUndo(data.undo)
                    .setRedo(data.redo)
                ;

                return session;
            }
        });
        return SessionFactory;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/SessionFactory.js
 ** module id = 893
 ** module chunks = 0
 **/